import config from '@project/config';

const articleBaseUrl = `${config.apiUrl}/articles`;

export default {
  getArticleUrl: (id: string) => `${articleBaseUrl}/${id}`,
};
